export default "__VITE_ASSET__wHprL$kI__"